import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/privacy-policy/page.tsx");
